import { render } from "./RichTextFieldInput.vue?vue&type=template&id=195f3139&scoped=true"
import script from "./RichTextFieldInput.vue?vue&type=script&lang=js"
export * from "./RichTextFieldInput.vue?vue&type=script&lang=js"

import "./RichTextFieldInput.vue?vue&type=style&index=0&id=195f3139&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195f3139"]])

export default __exports__